import _taggedTemplateLiteral from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
export var StepperIconContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 8px;\n  height: 8px;\n  min-width: 8px;\n  min-height: 8px;\n  margin: 0;\n  border-radius: 50%;\n  background-color: ", ";\n  z-index: 2;\n"])), function (props) {
  return props.color;
});